import React from "react";

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="about-grid">
          <div className="about-content">
            <span className="about-subtitle">L'Excellence Automobile</span>
            <h2 className="about-title">À propos de Christophe Dépanne</h2>
            <div className="title-accent"></div>
            
            <p className="about-paragraph">
              <strong>Christophe Dépanne</strong>, votre garage automobile de confiance situé à Lahage (31370), 
              vous accueille au 1280 Chemin de la Sabaillane. Nous sommes spécialisés dans l'entretien, 
              la réparation et le dépannage de véhicules toutes marques.
            </p>
            
            <p className="about-paragraph">
              Avec une équipe passionnée et expérimentée, nous nous engageons à fournir un service de qualité, 
              rapide et transparent. Fiers de notre disponibilité, nous sommes à votre service 
              <strong> 24h/24 </strong> pour répondre à vos urgences.
            </p>

            <div className="about-highlights">
              <div className="highlight-item">
                <div className="highlight-icon">🛠️</div>
                <div className="highlight-text">
                  <h3>Toutes Marques</h3>
                  <p>Réparation complète</p>
                </div>
              </div>
              <div className="highlight-item">
                <div className="highlight-icon">⏱️</div>
                <div className="highlight-text">
                  <h3>Dispo 24h/24</h3>
                  <p>Service d'urgence</p>
                </div>
              </div>
              <div className="highlight-item">
                <div className="highlight-icon">⭐</div>
                <div className="highlight-text">
                  <h3>Satisfaction</h3>
                  <p>Priorité absolue</p>
                </div>
              </div>
            </div>
          </div>

          <div className="about-image-wrapper">
            <div className="image-experience-badge">
              <span className="years">L'Expérience</span>
              <span className="text">Christophe Dépanne</span>
            </div>
            <img 
              src="/images/about_macro.png" 
              alt="Expertise Mécanique Christophe Dépanne" 
              className="about-image" 
            />
            <div className="image-border-accent"></div>
          </div>
        </div>
      </div>

      <style>{`
        .about-section {
          padding: 100px 20px;
          background-color: #f8fafc;
          overflow: hidden;
        }

        .container {
          max-width: 1200px;
          margin: 0 auto;
        }

        .about-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 80px;
          align-items: center;
        }

        .about-subtitle {
          text-transform: uppercase;
          letter-spacing: 3px;
          color: #1A365D;
          font-weight: 700;
          font-size: 0.9rem;
          margin-bottom: 15px;
          display: block;
        }

        .about-title {
          font-size: 3rem;
          color: #1a202c;
          margin-bottom: 25px;
          font-weight: 800;
          line-height: 1.1;
        }

        .title-accent {
          width: 60px;
          height: 4px;
          background-color: #1A365D;
          margin-bottom: 40px;
          border-radius: 2px;
        }

        .about-paragraph {
          font-size: 1.15rem;
          color: #4a5568;
          line-height: 1.8;
          margin-bottom: 20px;
        }

        .about-highlights {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
          gap: 20px;
          margin-top: 50px;
        }

        .highlight-item {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 15px;
          background: white;
          border-radius: 12px;
          box-shadow: 0 4px 6px rgba(0,0,0,0.02);
          transition: transform 0.3s ease;
        }

        .highlight-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 15px rgba(0,0,0,0.05);
        }

        .highlight-icon {
          font-size: 1.5rem;
          width: 45px;
          height: 45px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f1f5f9;
          border-radius: 10px;
        }

        .highlight-text h3 {
          font-size: 0.95rem;
          margin-bottom: 2px;
          color: #1a202c;
          font-weight: 700;
        }

        .highlight-text p {
          font-size: 0.8rem;
          color: #718096;
        }

        .about-image-wrapper {
          position: relative;
          padding: 20px;
        }

        .about-image {
          width: 100%;
          height: auto;
          border-radius: 20px;
          position: relative;
          z-index: 2;
          box-shadow: 20px 20px 60px rgba(0,0,0,0.1);
        }

        .image-border-accent {
          position: absolute;
          top: 0;
          right: 0;
          width: 80%;
          height: 80%;
          border: 10px solid #1A365D;
          border-radius: 20px;
          z-index: 1;
        }

        .image-experience-badge {
          position: absolute;
          bottom: 40px;
          left: -20px;
          background: #1A365D;
          color: white;
          padding: 20px 30px;
          border-radius: 15px;
          z-index: 3;
          box-shadow: 0 10px 30px rgba(26, 54, 93, 0.3);
          display: flex;
          flex-direction: column;
          align-items: center;
        }

        .image-experience-badge .years {
          font-size: 0.9rem;
          font-weight: 300;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .image-experience-badge .text {
          font-size: 1.1rem;
          font-weight: 700;
        }

        @media (max-width: 968px) {
          .about-grid {
            grid-template-columns: 1fr;
            gap: 60px;
          }
          .about-title { font-size: 2.5rem; }
          .about-image-wrapper { max-width: 600px; margin: 0 auto; }
        }

        @media (max-width: 480px) {
          .about-title { font-size: 2rem; }
          .highlight-item { padding: 10px; }
          .image-experience-badge { left: 10px; bottom: 20px; padding: 15px 20px; }
        }
      `}</style>
    </section>
  );
};

export default About;